import { atom } from 'recoil';

import { Node } from 'reactflow';

import { BlockAIThemeType, Hyperparameter, RightSideBarTab } from 'types';
import { COOKEY_KEY } from 'constants/cookieConstants';
import { getCookie, setCookie } from 'utils/cookieUtils';
import { THEME_TYPE } from 'constants/themeConstants';

export const themeTypeState = atom<BlockAIThemeType>({
  key: 'themeTypeState',
  default: (() => {
    const themeType = getCookie(COOKEY_KEY.THEME_TYPE);
    if (!themeType) {
      setCookie(COOKEY_KEY.THEME_TYPE, THEME_TYPE.LIGHT, {
        path: '/',
      });
      return THEME_TYPE.LIGHT;
    }
    return themeType;
  })(),
});

type ModalInfoState = {
  [key: string]: React.ReactNode;
};

export const modalInfoState = atom<ModalInfoState>({
  key: 'modalInfoState',
  default: {},
});

export const hyperparameterState = atom<Hyperparameter>({
  key: 'hyperparameterState',
  default: undefined,
});

export const rightSideBarTabState = atom<RightSideBarTab | undefined>({
  key: 'rightSideBarTabState',
  default: 'hyperparameter',
});

export const rightSideBarWidthState = atom({
  key: 'rightSideBarWidthState',
  default: 384,
});

export const selectedNodeState = atom<Node | undefined>({
  key: 'selectedNodeState',
  default: undefined,
});

export const takeSnapshotState = atom<{
  undoRedo?: () => void;
  projectChange?: () => void;
  updateCode?: () => void;
}>({
  key: 'takeSnapshotState',
  default: {},
});

export const rightSideBarFullState = atom({
  key: 'rightSideBarFullState',
  default: false,
});

export const shouldUpdateCodeState = atom({
  key: 'shouldUpdateCodeState',
  default: false,
});

export const isProjectChangeState = atom({
  key: 'isProjectChangeState',
  default: false,
});
